import { useCallback, useEffect, useState } from 'react';

export const usePolling = <T>(fetchData: () => Promise<T>, interval = 5000) => {
    const [data, setData] = useState<T | null>(null);
    const [error, setError] = useState<{ message: string } | null>(null);
    const [isPolling, setIsPolling] = useState(false);

    const startPolling = useCallback(() => {
        setIsPolling(true);
    }, []);

    const stopPolling = useCallback(() => {
        setIsPolling(false);
    }, []);

    useEffect(() => {
        let timeoutId: NodeJS.Timeout | null = null;

        const poll = async () => {
            try {
                const data = await fetchData();
                if (isPolling) {
                    setData(data);
                    setError(null);
                }
            } catch (err) {
                if (isPolling) {
                    setError(err as { message: string });
                }
            } finally {
                if (isPolling) {
                    timeoutId = setTimeout(poll, interval);
                }
            }
        };

        if (isPolling) {
            poll();
        }

        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            setIsPolling(false);
        };
    }, [fetchData, isPolling, interval]);

    return { data, error, isPolling, startPolling, stopPolling };
};
